import styled from "styled-components";
import { Drawer } from "antd";

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: 0;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
`;

export const DrawerContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
`;

export const DrawerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 24px 16px;
  border-bottom: 1px solid #e5e7eb;
`;

export const DrawerTitle = styled.h2`
  margin: 0;
  font-family: Inter, sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: #111827;
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #111827;
  font-size: 22px;
  line-height: 1;

  &:hover {
    opacity: 0.7;
  }
`;

export const ColumnHeaders = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 16px;
  padding: 16px 24px 8px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #6b7280;
`;

export const ItemsList = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 24px;
`;

export const EmptyState = styled.div`
  padding: 48px 24px;
  text-align: center;
  color: #6b7280;
  font-size: 15px;
`;

export const CartItem = styled.div`
  display: grid;
  grid-template-columns: 72px 1fr auto;
  gap: 16px;
  padding: 20px 0;
  border-bottom: 1px solid #f3f4f6;
  align-items: start;
`;

export const ItemImage = styled.img`
  width: 72px;
  height: 72px;
  object-fit: cover;
  border-radius: 4px;
  background: #f3f4f6;
`;

export const ItemImagePlaceholder = styled.div`
  width: 72px;
  height: 72px;
  border-radius: 4px;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  color: #9ca3af;
`;

export const ItemDetails = styled.div`
  min-width: 0;
`;

export const ItemName = styled.p`
  margin: 0 0 6px;
  font-size: 14px;
  font-weight: 500;
  color: #111827;
  line-height: 1.4;
`;

export const ItemPrice = styled.p`
  margin: 0 0 12px;
  font-size: 14px;
  color: #111827;
`;

export const QuantityRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const QuantityControl = styled.div`
  display: inline-flex;
  align-items: center;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  overflow: hidden;
`;

export const QuantityButton = styled.button`
  width: 36px;
  height: 36px;
  border: none;
  background: #fff;
  color: #111827;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;

  &:hover:not(:disabled) {
    background: #f9fafb;
  }

  &:disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }
`;

export const QuantityValue = styled.span`
  min-width: 36px;
  text-align: center;
  font-size: 14px;
  color: #111827;
  border-left: 1px solid #d1d5db;
  border-right: 1px solid #d1d5db;
  line-height: 36px;
`;

export const RemoveButton = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  color: #6b7280;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #111827;
  }
`;

export const LineTotal = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #111827;
  padding-top: 2px;
  white-space: nowrap;
`;

export const DrawerFooter = styled.div`
  padding: 20px 24px 24px;
  border-top: 1px solid #e5e7eb;
  background: #fff;
`;

export const SubtotalRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 16px;
  color: #111827;
`;

export const SubtotalLabel = styled.span`
  font-weight: 500;
`;

export const SubtotalValue = styled.span`
  font-weight: 600;
`;

export const FooterNote = styled.p`
  margin: 0 0 16px;
  font-size: 13px;
  color: #6b7280;
`;

export const CheckoutButton = styled.button`
  width: 100%;
  min-height: 48px;
  border: none;
  border-radius: 10px;
  background: #e8521a;
  color: #fff;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.01em;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(232, 82, 26, 0.28);
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background: #d44415;
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
    box-shadow: none;
  }
`;
